module.exports = __webpack_public_path__ + "media/assets/faria_products/AssessPrep-188f644cce3e5081094fb947c504d8530acc3ac6e3f696ad3499582534cd7eab.png";